const injuryTypes = [
  { id: 1, value: 'Bruising' },
  { id: 2, value: 'Burns' },
  { id: 3, value: 'Cuts Laceration' },
  { id: 4, value: 'Foreign body' },
  { id: 5, value: 'Fractures' },
  { id: 6, value: 'Infections' },
  { id: 7, value: 'Other' },
  { id: 8, value: 'Rash' },
  { id: 9, value: 'Sprains Strains' }
];

const injuryCauses = [
  { id: 1, value: 'Biological factors' },
  { id: 2, value: 'Body stress' },
  { id: 3, value: 'Hit by an object' },
  { id: 4, value: 'Hit with body' },
  { id: 5, value: 'Slip trip' },
  { id: 6, value: 'Chemical' },
  { id: 7, value: 'Heat' },
  { id: 8, value: 'Processing tool' },
  { id: 9, value: 'Sound pressure' }
];

const injuryLocations = [
  { id: 1, value: 'Arms' },
  { id: 2, value: 'Back' },
  { id: 3, value: 'Hands/fingers' },
  { id: 4, value: 'Head' },
  { id: 5, value: 'Legs/feet' },
  { id: 6, value: 'Lower body' },
  { id: 7, value: 'Upper body' },
  { id: 8, value: 'Other' }
];

export default { injuryTypes, injuryCauses, injuryLocations };
